import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from '../svgs/K1_Proximity_card.svg'

const K1Proximitycard: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 60 60'} component={Icon} {...props} fill="currentColor" />
export default K1Proximitycard
